<!-- src/js/widgets/manager-requests/components/StatusFilterSimple.vue -->
<template>
  <div class="manager-requests__filter-bar">
    <label for="status-filter" class="manager-requests__filter-bar-label">Фильтр по статусу:</label>
    <Select
      id="status-filter"
      v-model="localValue"
      :options="statusOptions"
      optionLabel="label"
      optionValue="value"
      placeholder="Все статусы"
      @update:model-value="onUpdate"
    />
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue';
import Select from 'primevue/select';
import type { RequestStatus } from '../types';

interface StatusOption {
  label: string;
  value: RequestStatus | '';
}

const props = defineProps<{
  modelValue: RequestStatus | '';
}>();

const emit = defineEmits<{
  (e: 'update:modelValue', value: RequestStatus | ''): void;
}>();

const statusOptions: StatusOption[] = [
  { label: 'Все статусы', value: '' },
  { label: 'Новая', value: 'Новая' },
  { label: 'В работе', value: 'В работе' },
  { label: 'Требуется информация', value: 'Требуется информация' },
  { label: 'Отклонена', value: 'Отклонена' },
  { label: 'Исполнена', value: 'Исполнена' },
];

const localValue = ref<RequestStatus | ''>(props.modelValue);

watch(
  () => props.modelValue,
  (newVal) => {
    localValue.value = newVal;
  },
);

function onUpdate(value: RequestStatus | ''): void {
  emit('update:modelValue', value);
}
</script>
